import React from 'react';
import PropTypes from 'prop-types';
import { FuseLoading } from '@fuse';

/**
 * React Suspense defaults
 * For to Avoid Repetition
 */

const defaultProps = {
  loadingProps: {
    delay: 300,
  },
};

function FuseSuspense({ loadingProps = defaultProps, children }) {
  return <React.Suspense fallback={<FuseLoading {...loadingProps} />}>{children}</React.Suspense>;
}

FuseSuspense.propTypes = {
  loadingProps: PropTypes.object,
};


export default FuseSuspense;
